import {
  createMyStore,
  deleteMyStore,
  getMyStores
} from 'features/my-store/api';
import { StoreType } from 'features/my-store/types/StoreType';
import { getNotifications } from 'features/notification/api';
import { hasUnread } from 'features/notification/utils/unread-checker';
import { API_RESPONSE_STATUS } from 'libs/constants';
import { unreadNotificationAtom } from 'libs/recoil/atom';
import { activeFeatureCodesState } from 'libs/recoil/selector';
import { useCallback, useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

export const useMyStore = () => {
  const [isDone, setIsDone] = useState<boolean>(false);
  const [myStores, setMyStores] = useState<StoreType[]>([]);
  const activeFeatureCodes = useRecoilValue(activeFeatureCodesState);
  const setUnreadNotification = useSetRecoilState(unreadNotificationAtom);
  const isFeatureActive = activeFeatureCodes.includes('store');

  useEffect(() => {
    if (isFeatureActive) {
      getMyStores().then((res) => {
        setMyStores(res);
        setIsDone(true);
      });
    }
  }, [isFeatureActive]);

  // マイ店舗更新時に、お知らせ未読マークの更新を行う
  const updateUnreadNotificationMark = useCallback(
    async (updatedStores: StoreType[]) => {
      const res = await getNotifications();
      if (res?.status === API_RESPONSE_STATUS.SUCCEEDED) {
        setUnreadNotification({
          hasUnread: hasUnread(res.data.notifications, updatedStores)
        });
      }
    },
    [setUnreadNotification]
  );

  const addMyStore = useCallback(
    (id: number) => {
      createMyStore(id).then(() => {
        getMyStores().then((res) => {
          setMyStores(res);
          updateUnreadNotificationMark(res);
        });
      });
    },
    [updateUnreadNotificationMark]
  );

  const removeMyStore = useCallback(
    (id: number) =>
      deleteMyStore(id).then(() => {
        getMyStores().then((res) => {
          setMyStores(res);
          updateUnreadNotificationMark(res);
        });
      }),
    [updateUnreadNotificationMark]
  );

  return { isFeatureActive, myStores, isDone, addMyStore, removeMyStore };
};
